import { render, staticRenderFns } from "./TestDraggingTable.vue?vue&type=template&id=7aa822be&scoped=true"
import script from "./TestDraggingTable.vue?vue&type=script&lang=js"
export * from "./TestDraggingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa822be",
  null
  
)

export default component.exports